import { Table, TableContainer, Tbody, Thead, Tr } from '@chakra-ui/table'
import { Box } from '@chakra-ui/layout'
import React, { useState } from 'react'
import { Td, Th } from './styles'
import { Flex } from '@chakra-ui/layout'
import InputFloating from '../../../components/InputFloating'
import { Button } from '@chakra-ui/button'
import { Checkbox, Text } from '@chakra-ui/react'
import { Modal } from './Modal'
import { baseURL } from '../../../services/api'
import { useForm } from 'react-hook-form'
import { Select } from '@chakra-ui/select'
import { Row } from './Row'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { usePdfGenerator } from '../../../hooks/usePdfGenerator'
import { user } from '../../../helpers/user'
import { format } from 'date-fns'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useVendedoresMensal } from '../../../hooks/useVendedoresMensal'
import { useEffect } from 'react'
import { permissoesUsuariosPropostas } from '../../../utils/permissoesUsuariosProposta'
import { FaArrowAltCircleDown } from 'react-icons/fa'

export function ResumoProducao() {
  const [dataItems, setDataItems] = React.useState([])
  const [newItems, setNewItems] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [gravacoes, setGravacoes] = React.useState([])
  const [passoAtual, setPassoAtual] = React.useState([])
  const [proximoPasso, setProximoPasso] = React.useState([])
  const [gravacoesSelecionadas, setGravacoesSelecionadas] = React.useState([])
  const [infosModal, setInfosModal] = React.useState([])
  const [searchParams] = useSearchParams()
  const { customers } = useVendedoresMensal()
  const codVend = searchParams.get('codVend')
  const history = useNavigate()
  const [orderBy, setOrderBy] = useState('new')
  const [orderByCompra, setOrderByCompra] = useState('new')

  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      numero_pedido: '',
    },
  })

  const visibleForThisUserCode = [0, 12, 30, 72, 85]
  const isVendedor = !!codVend

  useEffect(() => {
    const newItems = dataItems.map((item) => {
      return {
        ...item,
        contador_duplicado_por_item: dataItems.filter((item2) => item2.PEDIDO === item.PEDIDO).length,
      }
    })
    setNewItems(newItems)
  }, [dataItems])

  const headData = [
    'DATA CLIENTE',
    'PEDIDO',
    'EMPRESA',
    'CODIGO',
    'ITENS',
    'DESCRIÇÃO',
    'COR',
    'QTD',
    'GRAVAÇÃO',
    'DATA COMPRA',
    'DATA \nRECEBIMENTO',
    'PASSO ATUAL',
    'PRÓXIMO PASSO',
    'PRAZO',
    `${visibleForThisUserCode.includes(user?.codigo_usuario) && !isVendedor ? 'LIMITE DE PRODUÇÃO' : isVendedor ? 'DATA SAÍDA' : ''}`,
    'ENTREGA',
  ]

  const mapBodyData = () => {
    return newItems.map((item) => [
      item.DATA_CLIENTE ? format(new Date(item.DATA_CLIENTE), 'dd/MM/yyyy HH:mm') : 'Sem data',
      item.PEDIDO,
      item.nome_empresa || 'N/A',
      item.CODIGO,
      `${item.contador_duplicado_por_item}/${item.contador_tela}`,
      firstLetterUpperCaseAndRestLowerCase(item.DESCRICAO),
      firstLetterUpperCaseAndRestLowerCase(item.COR),
      item.batidas && item.batidas > 1 ? item.QUANTIDADE + ' x ' + item.batidas : item.QUANTIDADE,
      firstLetterUpperCaseAndRestLowerCase(item.GRAVACAO),
      item.DATA_COMPRA ? format(new Date(item.DATA_COMPRA), 'dd/MM/yyyy HH:mm') : 'Sem data',
      item.DATA_RECEBIMENTO ? format(new Date(item.DATA_RECEBIMENTO), 'dd/MM/yyyy HH:mm') : 'Sem data',
      item.PASSO_ATUAL,
      item.PROXIMO_PASSO,
      item.PRAZO + ' dias',
      // item.PREVISAO_SAIDA
      //   ? format(new Date(item.PREVISAO_SAIDA), 'dd/MM/yyyy HH:mm')
      //   : 'Sem data',
      visibleForThisUserCode.includes(user?.codigo_usuario) && !isVendedor
        ? item.PREVISAO_SAIDA
          ? format(new Date(item.PREVISAO_SAIDA), 'dd/MM/yyyy HH:mm')
          : 'Sem data'
        : isVendedor
          ? item.data_saida
          : '',

      firstLetterUpperCaseAndRestLowerCase(item.ENTREGA),
    ])
  }

  const generatePDF = usePdfGenerator(headData, mapBodyData, 'Resumo de Produção')

  async function getDataResumoProduction(data) {
    setLoading(true)
    try {
      const response = await baseURL.post('/pedido/resumo-producao', {
        data_saida: '',
        data_entrada: '',
      })

      let dataBack = response.data?.lista.map((item) => {
        return {
          ...item,
          data_saida: item.data_saida ? format(new Date(item.data_saida), 'dd/MM/yyyy') : 'Sem data',
        }
      })

      if (codVend && codVend !== '0' && codVend !== '8') {
        dataBack = dataBack.filter((item) => item.codigo_vendedor === codVend)
      }

      setInfosModal(dataBack)
      let filteredData = dataBack

      // Filtro de número do pedido
      if (data?.numero_pedido) {
        filteredData = filteredData.filter((item) => item.PEDIDO === data.numero_pedido)
      }

      // Filtro de gravações selecionadas
      if (gravacoesSelecionadas.length > 0) {
        if (gravacoesSelecionadas.includes('Colorida')) {
          filteredData = filteredData.filter(
            (item) => item.GRAVACAO.toLowerCase().includes('silk digital') || item.GRAVACAO.toLowerCase().includes('colorida')
          )
        } else {
          filteredData = filteredData.filter((item) =>
            gravacoesSelecionadas.map((gravacao) => gravacao.toLowerCase()).includes(item.GRAVACAO.split(' ')[0].toLowerCase())
          )
        }
      }

      // Filtro de passo atual
      if (data?.passo_atual) {
        filteredData = filteredData.filter((item) => item.PASSO_ATUAL === data.passo_atual)
      }

      // Filtro de próximo passo
      if (data?.proximo_passo) {
        filteredData = filteredData.filter((item) => item.PROXIMO_PASSO === data.proximo_passo)
      }

      // Filtro de data de início e fim
      if (data?.data_inicio && data?.data_fim) {
        filteredData = filteredData.filter((item) => {
          const previsaoSaida = item.PREVISAO_SAIDA.substring(0, 10) // Extraindo a data no formato 'YYYY-MM-DD'
          return previsaoSaida >= data.data_inicio && previsaoSaida <= data.data_fim
        })
      }

      setDataItems(filteredData)

      const arrayPassoAtual = response.data.lista.map((item) => item.PASSO_ATUAL)
      const uniquePassoAtual = [...new Set(arrayPassoAtual)]
      const arrayProximoPasso = response.data.lista.map((item) => item.PROXIMO_PASSO)
      const uniqueProximoPasso = [...new Set(arrayProximoPasso)]
      const arrayGravacoes = response.data.lista.map((item) => item.GRAVACAO)

      const objectGravacoes = {
        Laser: 0,
        Serigrafia: 0,
        Tampografia: 0,
        Uv: 0,
        Transfer: 0,
        Silk: 0,
        Marca: 0,
        Etiqueta: 0,
        Placa: 0,
        'S/Impressão': 0,
        DTF: 0,
        Colorida: 0,
      }

      response.data.lista?.forEach((item) => {
        Object.keys(objectGravacoes).forEach((tipoGravacao) => {
          if (item.GRAVACAO.toLowerCase().includes(tipoGravacao.toLowerCase())) {
            objectGravacoes[tipoGravacao] += parseInt(item.QUANTIDADE)
          }
        })
      })

      const arrayGravacoesChaveValor = Object.keys(objectGravacoes).map((key) => ({
        chave: key,
        valor: objectGravacoes[key],
      }))

      const uniqueGravacoes = arrayGravacoesChaveValor.filter((item) => item.valor > 0)

      setGravacoes(uniqueGravacoes)
      setPassoAtual(uniquePassoAtual)
      setProximoPasso(uniqueProximoPasso)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    getDataResumoProduction()
  }, [])

  useEffect(() => {
    if (codVend) {
      getDataResumoProduction()
    }
  }, [codVend])

  const counterNumPed = dataItems.filter((item, index, self) => self.findIndex((t) => t.PEDIDO === item.PEDIDO) === index).length

  const totalPecas = dataItems?.reduce((acc, item) => {
    return acc + parseInt(item.QUANTIDADE)
  }, 0)

  function handleGravacoes(gravacao) {
    const gravacoesSelecionadasCopy = [...gravacoesSelecionadas]
    if (gravacoesSelecionadasCopy.includes(gravacao)) {
      const index = gravacoesSelecionadasCopy.indexOf(gravacao)
      gravacoesSelecionadasCopy.splice(index, 1)
    } else {
      gravacoesSelecionadasCopy.push(gravacao)
    }
    setGravacoesSelecionadas(gravacoesSelecionadasCopy)
  }

  function filtroPorPrazo(prazo) {
    //procura no array de listagem a variavel prazo e retorna um novo array com os valores encontrados
    const filteredPrazo = infosModal.filter((item) => item.PRAZO === prazo)
    setDataItems(filteredPrazo)
  }

  function filtroPorEntrega(entrega) {
    //filtra a entrega que mais parece com a entrega que o usuario digitou
    const filteredEntrega = infosModal.filter((item) => item.ENTREGA.toLowerCase().includes(entrega))
    setDataItems(filteredEntrega)
  }

  const permissoesVendedor = {
    codigosPermitidos: ['10', '0', '8'],
    temPermissao: function (codigo, codVend) {
      if (codigo === '0') return true

      if (codVend) {
        return this.codigosPermitidos.includes(codigo) && codigo === codVend
      }

      return this.codigosPermitidos.includes(codigo)
    },
  }

  console.log(codVend)

  if (!permissoesVendedor.temPermissao(user?.codigo_vendedor, codVend)) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh" fontSize="1.5rem" fontWeight="bold">
        Você não tem permissão para acessar essa página
      </Flex>
    )
  }

  function orderByDate() {
    if (orderBy === 'new') {
      setOrderBy('old')
      setNewItems(
        newItems.sort((a, b) => {
          const dateA = a.DATA_RECEBIMENTO ? new Date(a.DATA_RECEBIMENTO) : new Date(0)
          const dateB = b.DATA_RECEBIMENTO ? new Date(b.DATA_RECEBIMENTO) : new Date(0)

          return dateB - dateA
        })
      )
    } else {
      setOrderBy('new')
      setNewItems(
        newItems.sort((a, b) => {
          const dateA = a.DATA_RECEBIMENTO ? new Date(a.DATA_RECEBIMENTO) : new Date(0)
          const dateB = b.DATA_RECEBIMENTO ? new Date(b.DATA_RECEBIMENTO) : new Date(0)

          return dateA - dateB
        })
      )
    }
  }

  function orderByDateCompra() {
    if (orderByCompra === 'new') {
      setOrderByCompra('old')
      setNewItems(
        newItems.sort((a, b) => {
          const dateA = a.DATA_COMPRA ? new Date(a.DATA_COMPRA) : new Date(0)
          const dateB = b.DATA_COMPRA ? new Date(b.DATA_COMPRA) : new Date(0)

          return dateB - dateA
        })
      )
    } else {
      setOrderByCompra('new')
      setNewItems(
        newItems.sort((a, b) => {
          const dateA = a.DATA_COMPRA ? new Date(a.DATA_COMPRA) : new Date(0)
          const dateB = b.DATA_COMPRA ? new Date(b.DATA_COMPRA) : new Date(0)

          return dateA - dateB
        })
      )
    }
  }

  return (
    <>
      <Flex w="full" alignItems="center" gap={2} position="relative" justifyContent="center" mx="auto">
        {permissoesUsuariosPropostas[user?.codigo_usuario] && (
          <Select
            ml={2}
            maxW="347px"
            w="full"
            minH="51px"
            borderRadius="0"
            m="0"
            value={codVend}
            onChange={(e) => {
              history(`/resumo-producao?codVend=${e.target.value}`)
            }}
          >
            <option value="">Selecione um vendedor</option>
            <option value="0">Todos</option>
            {customers?.map((customer) => (
              <option key={customer.codigo_usuario} value={customer.codvend}>
                {customer.apelido}
              </option>
            ))}
          </Select>
        )}
        <Box paddingBlock="14px" bg={'#378BBF'} textAlign="center" fontSize="16px" color="white" fontWeight="bold" w="full">
          <Text mr={user?.codigo_usuario === 30 && '420px'}>Resumo Produção</Text>
        </Box>
      </Flex>
      <Flex
        marginTop="1.5rem"
        mb={1}
        maxW="1050px"
        marginInline="auto"
        justifyContent="space-between"
        gap={2}
        as="form"
        onSubmit={handleSubmit(getDataResumoProduction)}
      >
        <InputFloating label="Número pedido" type="number" {...register('numero_pedido')} />
        <InputFloating label="De: " type="date" {...register('data_inicio')} />
        <InputFloating label="Até:" type="date" {...register('data_fim')} />
        {/* <Select placeholder="Gravação" {...register('gravacao')}>
          <option value="">Todos</option>
          {gravacoes.map((item) => (
            <option key={item} value={item.chave}>
              {item.chave}
            </option>
          ))}
        </Select> */}
        <Select placeholder="Passo atual" {...register('passo_atual')}>
          <option value="">Todos</option>
          {passoAtual.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>
        <Select placeholder="Próximo passo" {...register('proximo_passo')}>
          <option value="">Todos</option>
          {proximoPasso.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>

        <Button Button variant="ghost" colorScheme="blue" type="submit">
          Buscar
        </Button>
      </Flex>

      <Flex gap={2} justifyContent="center">
        {gravacoes.map((item) => (
          <Flex
            as="label"
            id={item.chave}
            htmlFor={item.chave}
            key={item.chave}
            alignItems="center"
            padding="0.5rem 1rem"
            borderRadius="0.5rem"
            bg="#F2F2F2"
            gap={2}
            cursor="pointer"
          >
            <Checkbox
              id={item.chave}
              name={item.chave}
              size="lg"
              colorScheme="blue"
              borderColor="blue.500"
              onChange={() => handleGravacoes(item.chave)}
            />

            <label htmlFor={item.chave}>
              <Text fontSize="1rem" fontWeight="bold" color="#606163">
                {item.chave}
              </Text>
            </label>
          </Flex>
        ))}
      </Flex>

      <Flex alignItems={'center'} justifyContent={'space-between'} paddingRight={'1rem'} mb={'1rem'}>
        <Button onClick={() => generatePDF(newItems)} variant="ghost" colorScheme="blue">
          Download PDF
        </Button>
        <Text fontSize="1rem" fontWeight="bold" color="#606163" marginLeft={'1rem'}>
          {counterNumPed} Pedidos - {dataItems?.length} Iten's - {totalPecas} Peças
        </Text>
        <Modal data={infosModal} loading={loading} filtroPorPrazo={filtroPorPrazo} filtroPorEntrega={filtroPorEntrega} />
      </Flex>
      <TableContainer maxW="100%" overflowX="auto" height="calc(100vh - 20rem)" overflowY="auto">
        <Table size="sm" variant="striped">
          <Thead position="sticky" top="0" bg="#378BBF" zIndex="1">
            <Tr>
              <Th>
                Data <br /> Cliente{' '}
              </Th>
              <Th>Pedido</Th>
              <Th>Empresa</Th>
              <Th>Codigo</Th>
              <Th>Itens</Th>
              <Th>Descrição</Th>
              <Th>Cor</Th>
              <Th>Qtd</Th>
              <Th>Gravação</Th>
              <Th>
                <Flex alignItems="center" justifyContent="center" cursor="pointer" gap={1}>
                  Data <br /> Compra
                  <FaArrowAltCircleDown
                    onClick={orderByDateCompra}
                    style={{
                      transform: orderByCompra === 'new' ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s',
                    }}
                    size={20}
                  />
                </Flex>
              </Th>
              <Th>
                <Flex alignItems="center" justifyContent="center" cursor="pointer" gap={1}>
                  Data <br /> Recebimento
                  <FaArrowAltCircleDown
                    onClick={orderByDate}
                    style={{
                      transform: orderBy === 'new' ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s',
                    }}
                    size={20}
                  />
                </Flex>
              </Th>
              <Th>Passo atual</Th>
              <Th>Próximo passo</Th>
              <Th>Prazo</Th>
              {visibleForThisUserCode.includes(user?.codigo_usuario) && !isVendedor && (
                <Th>
                  Limite <br /> de <br /> produção
                </Th>
              )}
              {isVendedor && <Th>Data Saída</Th>}
              {/*<Th>Usuário Emissão Nota</Th>*/}
              {/*<Th>Usuário Geração Etqt</Th>*/}
              {visibleForThisUserCode.includes(user?.codigo_usuario) && <Th>Entrega</Th>}
            </Tr>
          </Thead>
          {loading && (
            <Tbody>
              <Tr>
                <Td colSpan="15">Carregando...</Td>
              </Tr>
            </Tbody>
          )}
          {!loading && dataItems?.length === 0 && (
            <Tbody>
              <Tr>
                <Td colSpan="15">Nenhum registro encontrado</Td>
              </Tr>
            </Tbody>
          )}
          {!loading && (
            <Tbody>
              {newItems.map((items, index) => {
                return (
                  <Row
                    key={index}
                    item={items}
                    index={index}
                    newDateItens={dataItems}
                    visibleForThisUserCode={visibleForThisUserCode}
                    isVendedor={isVendedor}
                  />
                )
              })}
            </Tbody>
          )}
        </Table>
      </TableContainer>
    </>
  )
}
